<nav class="cerrix-navbar">
    @if (isHolidaySeason) {
        <div class="holidayseason">
            <navbar-snow></navbar-snow>
        </div>
    }
    <div class="logo">
        <cerrix-logo [width]="200" [height]="35"></cerrix-logo>
    </div>

    @if (isHolidaySeason && lightsEnabled) {
        <navbar-lightrope class="lightrope" [visible]="lightsEnabled"></navbar-lightrope>
    } @else {
        <div class="filler"></div>
    }

    <app-navbar-i18n-feedback></app-navbar-i18n-feedback>
    <navbar-calendar></navbar-calendar>
    <app-navbar-bug-report></app-navbar-bug-report>
    <navbar-help></navbar-help>
    <navbar-user
        [(lightRopeEnabled)]="lightsEnabled"
        [isHolidaySeason]="isHolidaySeason"
    ></navbar-user>
</nav>
